module.exports = __webpack_public_path__ + "static/media/eduBlue.a6359ac0.svg";